<template>
<div>
    <v-chip v-for="(tag, tagIndex) in tagArray" @click:close="remove(tag)" close dark  class="mr-1 mt-1" :color="tag.colour" :key="tagIndex">{{tag._id | space}}</v-chip>
</div>


</template>



<script>
import DataHelpers from '../helpers/DataHelpers'
import AlertHelpers from '../helpers/AlertHelpers'
import StringHelpers from '../helpers/StringHelpers'

export default {
    data() {
        return {
            tagArray: [],
        }
    },

    components: {
    },
    
    props: {
        tags: Object,
        availableTags: Array,
    },

    computed: {
        attributes() {

        }
    },

    methods: {
        async remove(tag) {
            if(await this.$root.$confirm('Remove', 'Are you sure you want to remove me from this group?', { color: 'yellow darken-2' }) == true) {
                this.$emit('remove', tag)
                console.log('removing', tag)
            }
        }
    },

    created() {

    },

    watch: {
        'tags': {
            deep: true,
            immediate: true,
            handler: function(newVal, oldVal) {
                let tagArray = []
                for(let prop in newVal) {
                    const item = this.availableTags.find(t => t._id == prop )
                    if(item)
                        tagArray.push(item)
                    else {
                        console.log('tagsView...not found ' + prop + ' in', this.availableTags.map(o => o._id).join(', '))
                    }

                }
                this.tagArray = tagArray
            }
        }
    }
}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// TagsView.vue?59c0dd8a